import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import AboutUs from './components/AboutUs';
import RealEstate from './components/RealEstate';
import Hospitality from './components/Hospitality';
import Commercial from './components/Commercial';
import Automobile from './components/Automobile';
import Agriculture from './components/Agriculture';
import BankingFinance from './components/BankingFinance';
import CSR from './components/CSR';
import Media from './components/Media';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
            </>
          } />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/real-estate" element={<RealEstate />} />
          <Route path="/hospitality" element={<Hospitality />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/automobile" element={<Automobile />} />
          <Route path="/banking_finance" element={<BankingFinance />} />
          <Route path="/agriculture" element={<Agriculture />} />
          <Route path="/csr" element={<CSR />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
